import { DatepickerRangeModel } from '../../../../../common/models';
import { LocalDateModel } from '../../../../models';

export const convertTimeFrameFilterToUTC = (
  timeFrame: DatepickerRangeModel,
  timezone: string,
): DatepickerRangeModel => {
  return Object.keys(timeFrame).reduce(
    (acc: { start: number; end: number }, key: string) => {
      const { timestamp } = LocalDateModel.createLocalDateWithCalculatedOffset(timeFrame[key], timezone);
      return { ...acc, [key]: timestamp };
    },
    { start: null, end: null },
  );
};
